import React from 'react';

interface TemplatesInAppGalleryProps {
  category?: string;
  templateSlug?: string;
}

export const TemplatesInAppGallery: React.FunctionComponent<
  TemplatesInAppGalleryProps
> = ({ category, templateSlug }) => {
  return (
    <div>
      <h1>PUT TEMPLATES IN-APP GALLERY HERE</h1>
      <br />
      <div>
        <strong>Category:</strong> <pre>{category}</pre>
      </div>
      <br />
      <div>
        <strong>Template Slug:</strong> <pre>{templateSlug}</pre>
      </div>
    </div>
  );
};
